// Libraries
import React, { useContext } from 'react';

// Components
import QuestionHeader from './QuestionHeader';
import QuestionItem from './QuestionItem';

// Services and Contexts
import QuestionsContext from '../../../contexts/QuestionsContext';

// Material-UI
import Box from '@material-ui/core/Box';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    borderLeft: 0,
    borderRight: 0,
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    display: 'block'
  }
}))(MuiAccordionDetails);

export default function QuestionBank() {
  const [expanded, setExpanded] = React.useState('');
  const questionBank = useContext(QuestionsContext).questions;

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const renderQuestions = (categoryIndex, expanded) => {
    const questions = questionBank[categoryIndex].questions;

    // Only rended questions belonging to currently expanded section
    if (expanded === questionBank[categoryIndex].category)
      return questions.map((question, questionIndex) => (
        <QuestionItem
          key={questionIndex}
          categoryIndex={categoryIndex}
          questionIndex={questionIndex}></QuestionItem>
      ));
  };

  const renderCategories = () => {
    if (questionBank.length > 0) {
      return questionBank.map((category, categoryIndex) => (
        <Accordion
          square
          key={categoryIndex}
          expanded={expanded === category.category}
          onChange={handleChange(category.category)}
          TransitionProps={{ timeout: 250 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <QuestionHeader categoryIndex={categoryIndex} />
          </AccordionSummary>
          <AccordionDetails>{renderQuestions(categoryIndex, expanded)}</AccordionDetails>
        </Accordion>
      ));
    } else {
      return null;
    }
  };

  return <Box>{renderCategories()}</Box>;
}
